// ─── Pagination ───────────────────────────────────────────────────────────────
export const ROWS_PER_PAGE_OPTIONS = [50, 100, 150, 200];
export const DEFAULT_ROWS_PER_PAGE = 50;

// ─── Month columns (order matters — Jan → Dec) ────────────────────────────────
export const MONTH_COLUMNS = [
    { title: "Jan", name: "jan" },
    { title: "Feb", name: "feb" },
    { title: "March", name: "march" },
    { title: "April", name: "april" },
    { title: "May", name: "may" },
    { title: "June", name: "jun" },
    { title: "July", name: "july" },
    { title: "Aug", name: "aug" },
    { title: "Sep", name: "sep" },
    { title: "Oct", name: "oct" },
    { title: "Nov", name: "nov" },
    { title: "Dec", name: "dec" },
];